/**
 * Faixa PERMANENTE do modo de visão (red team 09/07).
 *
 * Antes o único sinal de "você está vendo como o cliente X" era um texto na
 * sidebar — que some quando ela está recolhida (vira um ícone de olho fácil de
 * ignorar). Numa demo ou no suporte, o operador esquecia a lente ligada e podia
 * clicar em coisas achando que estava no próprio painel.
 *
 * Agora: faixa fixa no topo, sempre visível, com quem está sendo observado, o
 * aviso de que é só leitura e a saída em 1 clique. Padrão de mercado (Stripe,
 * Salesforce mostram barra permanente durante impersonation).
 *
 * Também carrega o "Voltar ao início" (24/07): ele vivia numa SEGUNDA faixa
 * inline no Layout que dizia a mesma frase que esta — as duas empilhadas na
 * mesma tela. A faixa duplicada saiu; o botão veio pra cá pra não se perder.
 */
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Eye, X } from "lucide-react";
import { useVerComo } from "../hooks/useVerComo";
import { useEmpresaAtiva } from "../hooks/useEmpresaAtiva";

export function VerComoBanner() {
  const { alvo, limpar } = useVerComo();
  const { ativa: empresaAtiva } = useEmpresaAtiva();
  const navigate = useNavigate();
  const loc = useLocation();
  const empresaSlug = empresaAtiva?.slug ?? "";
  if (!alvo) return null;

  // "Início" DA PESSOA que está sendo observada — não o meu. Cliente cai no
  // portal dela (Regula tem o próprio); interno cai no painel. Só aparece
  // quando a lente está ligada numa tela INTERNA: na própria inicial o botão
  // não levaria a lugar nenhum.
  const inicio =
    alvo.role === "cliente"
      ? empresaSlug === "regula360" || empresaSlug === "vitrine-reg"
        ? "/portal-regula"
        : "/portal"
      : "/";
  const naInicial = loc.pathname === inicio;

  return (
    <div className="sticky top-0 z-50 w-full bg-amber-400 text-[#241c0c] px-3 py-1.5 flex items-center gap-2 text-[12.5px] font-medium shadow">
      <Eye className="h-3.5 w-3.5 shrink-0" />
      <span className="truncate">
        Você está vendo o painel como <b>{alvo.nome}</b>
        {alvo.clienteNome ? ` (${alvo.clienteNome})` : ""}, apenas leitura, e este acesso fica registrado.
      </span>
      <div className="ml-auto shrink-0 flex items-center gap-1.5">
        {/* Secundário de propósito: continuar NA lente, só voltando pro começo.
            O primário (escuro) é sair dela. */}
        {!naInicial && (
          <button
            onClick={() => navigate(inicio)}
            className="shrink-0 inline-flex items-center gap-1 bg-[#241c0c]/10 hover:bg-[#241c0c]/20 transition-colors rounded px-2 py-0.5 text-[11.5px] font-semibold"
          >
            <ArrowLeft className="h-3 w-3" /> Voltar ao início
          </button>
        )}
        <button
          onClick={() => {
            limpar();
            navigate("/");
          }}
          className="shrink-0 inline-flex items-center gap-1 bg-[#241c0c] text-amber-300 rounded px-2 py-0.5 text-[11.5px] font-semibold"
        >
          <X className="h-3 w-3" /> Sair da visão
        </button>
      </div>
    </div>
  );
}
